module.exports = __webpack_public_path__ + "assets/img/five.8e78bfd5.png";